import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import RecoverPasswordPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { registerState } from '../../../../common/Services/RegistrationService.js';
import RecoverPasswordPanelActions from './redux/actions';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'recoverPasswordPanel';
import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createRecoverPasswordScreen = ({ userId, userEmail, userRoles }) => {
  const root = createRoot(document.getElementById('recoverPasswordPanel'));
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    const isSupportUser = userRoles.filter((role) => -1 !== ['ROLE_ROOT', 'ROLE_SUPPORT'].indexOf(role)).length >= 1;
    store.dispatch(RecoverPasswordPanelActions.bootstrap(userId, userEmail, isSupportUser));

    root.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <RecoverPasswordPanel />
        </AuthScreenLayout>
      </Provider>
    );
  } else {
    root.render(<UnsupportedBrowsers />);
  }
};

window.createRecoverPasswordScreen = createRecoverPasswordScreen;
export { namespace };
